export async function asyncSome<T>(arr: T[], predicate: (param: T) => Promise<boolean>): Promise<boolean> {
  for (const e of arr) {
    if (await predicate(e)) {
      return true;
    }
  }

  return false;
}
